/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Policy type ID
 */
export var PolicyType;

(function (PolicyType) {
  PolicyType["ANNUAL"] = "annual";
  PolicyType["ANNUAL_FLEXIBLE"] = "annual_flexible";
  PolicyType["CONTRACT_SPECIFIC"] = "contract_specific";
  PolicyType["PAUSE"] = "pause";
  PolicyType["UNPAUSE"] = "unpause";
})(PolicyType || (PolicyType = {}));